import React, { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

const COLORS = ['#ffcc00', '#f08a3c', '#d9622b', '#b8451d', '#e8a33d'];

const fall = keyframes`
  0%   { transform: translate3d(0, -12%, 0) rotate(0deg); opacity: 0; }
  10%  { opacity: 1; }
  50%  { transform: translate3d(var(--sway), 55vh, 0) rotate(var(--spin-mid)); }
  90%  { opacity: 1; }
  100% { transform: translate3d(calc(var(--sway) * -0.4), 112vh, 0) rotate(var(--spin)); opacity: 0; }
`;

const LeafShape = ({ color }) => (
  <svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true">
    <path
      d="M12 2C6 6 4 12 7 17c1.4 2.2 3.4 3.4 5 5 1.6-1.6 3.6-2.8 5-5 3-5 1-11-5-15z"
      fill={color}
    />
    <path
      d="M12 5v16"
      stroke="rgba(0,0,0,0.25)"
      strokeWidth="1"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);

/**
 * Foglie autunnali che cadono lentamente. Solo CSS (nessun JS per frame),
 * posizionate in absolute: il contenitore deve avere position e overflow hidden.
 */
const FallingLeaves = ({ count = 14 }) => {
  const leaves = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => {
        const size = 14 + Math.random() * 16;
        return {
          id: i,
          left: Math.random() * 100,
          size,
          color: COLORS[i % COLORS.length],
          duration: 9 + Math.random() * 8,
          delay: -Math.random() * 14,
          sway: (Math.random() - 0.5) * 90,
          spin: (Math.random() > 0.5 ? 1 : -1) * (180 + Math.random() * 360),
          opacity: 0.55 + Math.random() * 0.35,
        };
      }),
    [count]
  );

  return (
    <Box
      aria-hidden
      position="absolute"
      inset={0}
      overflow="hidden"
      pointerEvents="none"
      zIndex={0}
      sx={{ '@media (prefers-reduced-motion: reduce)': { display: 'none' } }}
    >
      {leaves.map((l) => (
        <Box
          key={l.id}
          position="absolute"
          top={0}
          left={`${l.left}%`}
          w={`${l.size}px`}
          h={`${l.size}px`}
          opacity={0}
          filter="drop-shadow(0 2px 3px rgba(0,0,0,0.35))"
          animation={`${fall} ${l.duration}s linear ${l.delay}s infinite`}
          willChange="transform"
          style={{
            '--sway': `${l.sway}px`,
            '--spin': `${l.spin}deg`,
            '--spin-mid': `${l.spin / 2}deg`,
          }}
        >
          <Box w="100%" h="100%" opacity={l.opacity}>
            <LeafShape color={l.color} />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default FallingLeaves;
